module.exports = __webpack_public_path__ + "static/media/market_service.567cc35b.svg";